<!--<igx-combo
    [data]="remoteData | async" [(ngModel)]="linkedUsers" (onSelectionChange)="handleUserLinking($event)"
    [displayKey]="'displayName'" [valueKey]="'userId'"></igx-combo>-->
<ul class="user-list">
    <li class="user-list-item" *ngFor="let user of linkedUsers | findUsersByIds: users">
        <ng-container *ngIf="user">
            <span class="user-title">{{ user.displayName }}</span>
            <div class="user-data-group" *ngIf="user.email">
                <span class="user-data-group-title">Email</span>
                <span class="user-data-group-body">{{ user.email }}</span>
            </div>
            <div class="user-data-group" *ngIf="user.telephone">
                <span class="user-data-group-title">Mobile</span>
                <span class="user-data-group-body">{{ user.telephone }}</span>
            </div>
        </ng-container>
    </li>
</ul>
